import React, { Component } from "react";
import "../../css/nanny.css";

export default class Stepper2 extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "10px",
          // marginTop: "-40px",
        }}
      >
        <div
          style={{
            height: "5px",
            width: "20px",
            background: '#77C9FB',
            borderRadius: "10px",
            marginRight: "2px",
          }}
        ></div>
        <div
          style={{
            height: "5px",
            width: "20px",
            background: "black",
            borderRadius: "10px",
            marginRight: "2px",
            background: '#77C9FB',
          }}
        ></div>
        <div
          style={{
            height: "5px",
            width: "20px",
            background: "black",
            borderRadius: "10px",
            background: '#B7BEC4',
          }}
        ></div>
      </div>
    );
  }
}
